import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './data/auth.service';

@Injectable({ providedIn: 'root' })
export class StudentGuard  {

    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }

    //if user is employee, do allow to access student pages
    //if user is both a student and employee, should have an account created for both and use User Switch function
    canActivate(): Promise<boolean> {
        return new Promise((resolve) => {
            this.authService.getAuthInfo().subscribe(
                auth => {
                    if (auth && auth.isAuthenticated) {
                        if (auth.securityType.toLowerCase() === 'employee' || auth.securityType.toLowerCase() === 'externalreviewer') {
                            this.router.navigate(['/school']);
                            resolve(false);
                        } else if (auth.securityType.toLowerCase() === 'donor') {
                            this.router.navigate(['/donor']);
                            resolve(false);
                        } else if (!(auth.securityType.toLowerCase() === 'student')) {
                            // we're essentially going to say if you're not a student at this point, you belong on the employee side
                            // this should only include CL security type really
                            this.router.navigate(['/school']);
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    } else {
                        resolve(true);
                    }
                });
        });
    }

    canActivateChild = () => this.canActivate();

}
